import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { TipologiaFascicoloCorrelataVO } from "../vo/tipologia-fascicolo-correlataVO";
import { TipologiaFascicoloCorrelataDTO } from "../dto/tipologia-fascicolo-correlataDTO";

@Injectable({
  providedIn: "root",
})
export class MapperTipologiaFascicoloCorrelata
  implements
    MapperInterface<
      TipologiaFascicoloCorrelataDTO,
      TipologiaFascicoloCorrelataVO
    > {
  convertVoToDto(
    vo: TipologiaFascicoloCorrelataVO
  ): TipologiaFascicoloCorrelataDTO {
    if (vo != null) {
      const dto = new TipologiaFascicoloCorrelataDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.codice = vo.codice;
      dto.nome = vo.nome;
      dto.id = vo.id;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(
    dto: TipologiaFascicoloCorrelataDTO
  ): TipologiaFascicoloCorrelataVO {
    if (dto != null) {
      const vo = new TipologiaFascicoloCorrelataVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.id = dto.id;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: TipologiaFascicoloCorrelataVO[]
  ): TipologiaFascicoloCorrelataDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: TipologiaFascicoloCorrelataDTO[]
  ): TipologiaFascicoloCorrelataVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
